import React from "react";
import HeadingText from "./Heading";
import SubheadingText from "./Subheading";
import ParagraphText from "./Paragraph";
import GalleryHorizontal from "./Gallery-Horizontal";
import LinkParagraph from "./Link-Paragraph";
import { Wrapper, Break } from "../styles/components/Global/Global";
import { Lotus } from "./Lotus-Objects";

const SectionBlooming = () => {
  const section = "blooming";
  const gallery = Lotus.galleries.find(gallery => gallery.name === section);

  return (
    <Wrapper className={`scene-switch ${section}`}>
      <Wrapper $margin>
        <LinkParagraph />
        <HeadingText text="Blooming" />
        <ParagraphText
          text="Ksawery Kirklewski pleads guilty to being a serial lo-fi head. “I love pixels,” gushes the Polish-born artist, “and I love big pixels.” Kirklewski—who goes by the online moniker Ksawery Komputery—has been entangled in an 8-bit love affair for as long as he can remember. From a young age, Ksawery was drawn toward technology with a distinctly retro flair, and has been quick to snatch up any and all digital artifacts he can get ahold of. He began his academic career in computer science, with little to no initial inclination toward pursuing a career in the arts.“"
          width="small"
          textAlign="left"
          indent={true}
        />
        <ParagraphText
          text="During my IT studies, I met many people from the Academy of Fine Arts who had similar interests to me who were also expressing their creativity through art.” "
          width="xlarge"
          align="flex-start"
          size="large"
          textAlign="left"
          weight="bold"
        />
        <ParagraphText
          text="Propelled by this newfound inspiration, he dropped his original degree program and would go on to himself become a graduate from Academy of Fine Arts in Gdańsk, Poland in 2015. After graduating, Ksawery married his two passions, and combined his two passions, giving rise to the practice he has now honed into a successful artistic career. "
          align="flex-end"
          textAlign="left"
          indent={true}
        />
        <Break $size="small" />
        <SubheadingText
          text="To this day, the methods he employs to build his works ring true to his original passions. “Today my practice is built on fine art, coding, and graphic design.” Working closely with his brother and technical manager Jakub Kirklewski, they create bright striking colors that bolt across the LED screen, evoking the golden age of arcade games, and towering technicolor sculptures seem plucked from highstreet in Shanghai circa 3023. But what is most striking about his work is how Ksawery builds the worlds in which his creations live. “Everything I make as an artist is done with coding. There’s no After Effects or Photoshop in my practice.”"
          width="large"
          textAlign="left"
          zIndex={true}
        />
        <Break $size="small" />
      </Wrapper>
      <Break $size="small" />
      <GalleryHorizontal gallery={gallery} />
      <Break $size="small" />
    </Wrapper>
  );
};

export default SectionBlooming;
